import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import FilterChip from 'LuxKit/Chips/FilterChip'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import ListingDrawerTitleGroup from '../ListingDrawerTitleGroup'

interface Props {
  placeName: string
  title?: string
  onExploreMap?: () => void
}

function ExperienceListingDrawerHeader({
  placeName,
  title,
  onExploreMap,
}: Props) {
  const intl = useIntl()

  return (
    <Group
      direction="horizontal"
      gap={16}
      horizontalAlign="space-between"
      verticalAlign="start"
    >
      <ListingDrawerTitleGroup direction="vertical" gap={4}>
        <Heading variant="heading2">
          {title ?? intl.formatMessage({
            id: 'V6Sb0Bka9c4FK9WOArYJ',
            defaultMessage: 'Experiences in {placeName}',
            description: 'Heading for the experience listing drawer showing available experiences for a specific stop location.',
          }, { placeName })}
        </Heading>
      </ListingDrawerTitleGroup>

      {onExploreMap && (
        <FilterChip
          size="medium"
          startIcon={<LineMapIcon />}
          onClick={onExploreMap}
        >
          {intl.formatMessage({
            id: 'cAg7XWiAJmj99PC48hv3',
            defaultMessage: 'Explore more',
            description:
              'Chip label on the trip planner experience listing drawer header that opens map explore for experiences at the current itinerary stop.',
          })}
        </FilterChip>
      )}
    </Group>
  )
}

export default ExperienceListingDrawerHeader
